import { C } from "../../lib/constants";

export const TopNav = ({back, backLabel="Volver", title, right, setScreen}) => (
  <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`,padding:"0 20px",position:"sticky",top:0,zIndex:50,boxShadow:"0 1px 8px rgba(0,0,0,0.06)"}}>
    <div style={{maxWidth:640,margin:"0 auto",padding:"14px 0",display:"flex",alignItems:"center",gap:12}}>
      <button onClick={()=>typeof back==="function"?back():setScreen(back)}
        style={{background:C.faint,border:"none",borderRadius:10,color:C.text,cursor:"pointer",fontSize:13,fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",fontWeight:600,padding:"8px 14px",flexShrink:0}}
        onMouseEnter={e=>{e.currentTarget.style.background=C.accentL;e.currentTarget.style.color=C.accent;}}
        onMouseLeave={e=>{e.currentTarget.style.background=C.faint;e.currentTarget.style.color=C.text;}}>
        ← {backLabel}
      </button>
      {title&&<div style={{fontFamily:"'Georgia',serif",fontSize:17,fontWeight:800,color:C.text,flex:1}}>{title}</div>}
      {right&&<div style={{marginLeft:"auto"}}>{right}</div>}
    </div>
  </div>
);
